import React from "react";
import { withStyles } from "@material-ui/core";
import { I18n } from "@aws-amplify/core";
import { get, filter, sortBy, size } from "lodash";

import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import Loader from "../../Common/Loader";
import SchedulerCalendar from "./SchedulerCalendar";
import SchedulerCalendarWeeklyPrint from "../SchedulerCalendarWeekly/SchedulerCalendarWeeklyPrint";

import { calendarViews } from "../../../constants/common";
import moment from "moment-timezone";
import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const styles = {
  formControlLabel: {
    color: colors.black54,
    fontSize: "1em",
    userSelect: "none",
  },
};

const SchedulerCalendarContainer = (props) => {
  const {
    classes,
    startDate,
    view,
    data,
    isFetching,
    // timeSlots,
    refresh,
    filters,
    handleFiltersChange,
  } = props;
  var visitCount;
  if (size(data) !== 0){
    visitCount = size(data.filter(data => data.when.toDate().toDateString() === startDate.toDateString()));
  }
  const userTimezone = moment.tz.guess();
  const timeStart = moment()
    .utc()
    .hours(0)
    .minute(0)
    .seconds(0)
    .milliseconds(0);
  const timeEnd = moment().utc().hours(0).minute(0).seconds(0).milliseconds(0);

  timeStart.hours(14);
  timeEnd.hours(16);
  const toUtc =
    moment(timeStart).tz(userTimezone).hours() -
    moment(timeStart).tz("Etc/UTC").hours();

  var timeSlots = sortBy(
    [
      {
        id: 1,
        start: {
          hours: (14 + toUtc) % 24,
          minutes: 0,
        },
        end: {
          hours: (16 + toUtc) % 24,
          minutes: 0,
        },
      },
      {
        id: 2,
        start: {
          hours: (18 + toUtc) % 24,
          minutes: 0,
        },
        end: {
          hours: (20 + toUtc) % 24,
          minutes: 0,
        },
      },
      {
        id: 3,
        start: {
          hours: (22 + toUtc) % 24,
          minutes: 0,
        },
        end: {
          hours: (24 + toUtc) % 24,
          minutes: 0,
        },
      }
    ],
    (item) => item.start.hours
  );

  const days = [];

  if (!startDate) return null;

  for (let i = 0; i < (view === calendarViews.daily ? 1 : 7); i++) {
    days.push({
      start: new Date(startDate.getTime() + 86400000 * i),
      occurrences: filter(
        data,
        (item) =>
          new Date(get(item, ["when"])) >=
            new Date(startDate.getTime() + 86400000 * i) &&
          new Date(get(item, ["when"])) <
            new Date(startDate.getTime() + 86400000 * (i + 1))
      ),
    });
  }

  var times = []
  var time_ends = []
  for (var i = 0; i<size(days); i++){
    for (var j = 0; j<size(days[i]["occurrences"]); j++){
      time_ends.push(parseInt(days[i]["occurrences"][j]["when"].local().format('HH'))+moment.duration({"minutes": days[i]["occurrences"][j]["events"][1]["relative_time_min"]}).hours())
      times.push(parseInt(days[i]["occurrences"][j]["when"].local().format('HH')))
    } 
  }
  times.sort(function(a,b){return a - b})
  time_ends.sort(function(a,b){return a - b})
  var start, end;
  if (times[0]<10){
    start = times[0]
  } else {
    start = 10
  }
  start = Math.min(start, 14)
  start = start +4
  if (start%2===1){
    start--
  }
  var id_times = 4
  if (start < 14){
    for (i=start; i<14; i=i+2){
      var temp = {
        id:id_times,
        start: {
          hours: (i + toUtc) % 24,
          minutes: 0,
        },
        end: {
          hours: (i+1 + toUtc) % 24,
          minutes: 0,
        },
      }
      id_times++
      timeSlots.push(temp)
    }
  }
  end = time_ends.slice(-1).pop()

  if (end > 21){
    for (i=25; i<=end+4;i=i+2){
      temp = {
        id:id_times,
        start: {
          hours: (i + toUtc) % 24,
          minutes: 0,
        },
        end: {
          hours: (i+1 + toUtc) % 24,
          minutes: 0,
        },
      }
      id_times++
      timeSlots.push(temp)
    }
  }
  

  timeSlots = sortBy(timeSlots, (item) => item.start.hours)


  if (isFetching) {
    return <Loader noDecoration height="100%" />;
  }

  return (
    <Grid
      container
      wrap="nowrap"
      direction="column"
      data-test="scheduler-calendar-component"
      style={{
        width: view === calendarViews.weekly ? "fit-content" : "",
        maxWidth: view === calendarViews.weekly ? "" : "1300px",
        overflow:"hidden"
      }}
    >
      <Grid item container alignItems="center">
        <Grid item xs style={{ marginLeft: "42px" }}>
          <span><img src={images.appointment_black} alt="clock" style={{position:"relative", top:"5px"}} /></span>
          {
            view === calendarViews.weekly ? <span>&nbsp;&nbsp;{size(
              data
            )}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> :           <span>&nbsp;&nbsp;{
              visitCount
            }&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          }

          <FormControlLabel
            control={
              <Checkbox
                checked={get(filters, ["showCustomTimeSlots"])}
                onChange={() =>
                  handleFiltersChange(
                    "showCustomTimeSlots",
                    null,
                    !get(filters, ["showCustomTimeSlots"])
                  )
                }
                name="showCustomTimeSlots"
                color="primary"
              />
            }
            label={I18n.get("scheduler_showCustomTimeSlots")}
            classes={{ label: classes.formControlLabel }}
          />
        </Grid>
        <Grid item xs style={{ textAlign: "right" }}>
          <SchedulerCalendarWeeklyPrint filters={filters}>
            <SchedulerCalendar
              timeSlots={timeSlots}
              days={days}
              view={view}
              refresh={refresh}
              filters={filters}
            />
          </SchedulerCalendarWeeklyPrint>
        </Grid>
      </Grid>
      <SchedulerCalendar
        timeSlots={timeSlots}
        days={days}
        view={view}
        refresh={refresh}
        filters={filters}
        end={end}
      />
    </Grid>
  );
};

export default withStyles(styles)(SchedulerCalendarContainer);